var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCactusHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 283.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cactus",
    transform: "translate(-89.583 -386.172)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 126,
    cy: 126,
    r: 126,
    transform: "translate(89.583 386.172)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cactus-2",
    "data-name": "cactus",
    transform: "translate(133.569 488.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M286.959,364.924c-4.56.055-15.735-.428-21.687-8.1-3.954-5.1-4.027-11.328-4.012-22.313.021-16.3,3.624-21.193-.4-27.895-2.556-4.254-7.714-8.455-12.692-7.738-6.943,1-10.079,11.076-10.986,13.989-3.15,10.123-.361,19.108,1.77,25.656,3.146,9.672,6.947,21.359,18.783,28.655,12.852,7.922,26.648,5.409,30.62,4.534",
    transform: "translate(-233.048 -284.686)",
    fill: "#9be09e",
    stroke: "#313860",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M559.233,307.876c-.147-1.04-3.489-23.582-12.065-24.559-3.874-.442-7.334,3.747-8.674,5.158-4.924,5.184-4.711,11.43-5.729,21.494-1.7,16.813-5.153,27.544-6.581,31.626-5.389,15.41-10.553,17.843-12.547,18.567a13.818,13.818,0,0,1-4.88.805c1.37-4.306,3.123-9.809,5.541-18.016,11.616-39.418,12.146-51.5,10.368-62.7-1.3-8.191-3.114-18.631-11.706-24.136l-.008-.006c-6.023-3.854-12.921-3.716-17.9-2.818a33.341,33.341,0,0,0-6.743,1.93c-3.937,1.679-14.123,7.088-22.819,33.4-6.016,18.2-7.569,35.064-7.281,58.644a484.348,484.348,0,0,0,5.929,69.565l12.045.225,16.8.314,7.2.134a197.289,197.289,0,0,1,3.565-37.766c.656-3.4,1.262-6.055,1.935-8.588a29.594,29.594,0,0,0,9.987,2.134c14.5.487,24.606-10.349,29.14-15.211C562.8,338.783,560,313.372,559.233,307.876Z",
    transform: "translate(-410.612 -247.937)",
    fill: "#a2f2a8",
    stroke: "#313860",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M637.905,356.187c11.616-39.418,12.146-51.5,10.368-62.7-1.3-8.191-3.114-18.631-11.706-24.136l-.008-.006a85.019,85.019,0,0,1,1.688,12.7c.9,16.057-3.132,26.775-8.407,44.029-8.262,27.016-14.478,47.351-16.119,65.75A122.587,122.587,0,0,0,616.6,430.6l7.2.134a197.281,197.281,0,0,1,3.565-37.766c2.353-12.2,4.052-14.751,10.545-36.786Z",
    transform: "translate(-534.422 -261.172)",
    fill: "#9be09e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M616.191,234.893a.511.511,0,0,1-.376.635.477.477,0,0,1-.656-.339,54.075,54.075,0,0,1-1.269-6.367,56.06,56.06,0,0,1,2.3,6.071Z",
    transform: "translate(-534.918 -228.822)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M563.873,395.607a.511.511,0,0,1-.2.711.479.479,0,0,1-.722-.158,53.859,53.859,0,0,1-2.875-5.822,56.349,56.349,0,0,1,3.8,5.269Z",
    transform: "translate(-491.961 -357.767)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M664.029,279.144a.512.512,0,0,1-.523.523.48.48,0,0,1-.551-.492,53.939,53.939,0,0,1,.359-6.483,56.445,56.445,0,0,1,.715,6.452Z",
    transform: "translate(-574.089 -263.845)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M725.648,422.411a.511.511,0,0,1-.734.072.479.479,0,0,1-.114-.73,54,54,0,0,1,4.388-4.786,56.268,56.268,0,0,1-3.54,5.444Z",
    transform: "translate(-623.369 -379.025)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M689.909,572.271a.513.513,0,0,1-.725-.146.479.479,0,0,1,.105-.732,53.8,53.8,0,0,1,5.6-3.293,56.757,56.757,0,0,1-4.976,4.171Z",
    transform: "translate(-594.936 -499.68)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M657.5,733.154a.512.512,0,0,1-.7-.233.48.48,0,0,1,.194-.713,53.649,53.649,0,0,1,5.956-2.585,56.268,56.268,0,0,1-5.448,3.531Z",
    transform: "translate(-569.111 -628.629)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M615.017,954.259a.511.511,0,0,1-.25-.695.478.478,0,0,1,.68-.288,53.621,53.621,0,0,1,5.712,3.088,56.613,56.613,0,0,1-6.142-2.105Z",
    transform: "translate(-535.583 -807.14)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M510.763,546.393a.512.512,0,0,1-.022.737.479.479,0,0,1-.738.021,54.183,54.183,0,0,1-4.192-4.959,56.1,56.1,0,0,1,4.952,4.2Z",
    transform: "translate(-448.638 -478.998)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M501.5,720.518a.511.511,0,0,1,.14.725.477.477,0,0,1-.715.181,53.757,53.757,0,0,1-5.175-3.921,56.515,56.515,0,0,1,5.75,3.015Z",
    transform: "translate(-440.609 -618.954)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M497.02,940.7a.512.512,0,0,1,.677.3.479.479,0,0,1-.26.691,54.044,54.044,0,0,1-6.172,2.013,56.4,56.4,0,0,1,5.756-3Z",
    transform: "translate(-437.026 -797.111)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M709.359,236.366a.511.511,0,0,1-.661.329.479.479,0,0,1-.366-.64,54.032,54.032,0,0,1,2.4-6.035,55.973,55.973,0,0,1-1.37,6.346Z",
    transform: "translate(-610.297 -229.778)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M774.865,320.876a.512.512,0,0,1-.733.1.478.478,0,0,1-.142-.724,53.787,53.787,0,0,1,4.192-4.958,56.611,56.611,0,0,1-3.317,5.581Z",
    transform: "translate(-662.65 -297.856)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M788,437.145a.511.511,0,0,1-.71-.2.478.478,0,0,1,.16-.721,53.945,53.945,0,0,1,5.83-2.857,56.506,56.506,0,0,1-5.28,3.78Z",
    transform: "translate(-673.278 -392.115)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M764.8,574.758a.51.51,0,0,1-.629-.386.479.479,0,0,1,.349-.65,53.6,53.6,0,0,1,6.388-1.166,56.57,56.57,0,0,1-6.108,2.2Z",
    transform: "translate(-654.88 -503.233)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M732.818,697.183a.512.512,0,0,1-.552-.491.478.478,0,0,1,.458-.579,54,54,0,0,1,6.492-.037,56.346,56.346,0,0,1-6.4,1.107Z",
    transform: "translate(-629.425 -601.787)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M744,847.634a.51.51,0,0,1,.143-.724.478.478,0,0,1,.731.1,53.84,53.84,0,0,1,3.31,5.586A56.331,56.331,0,0,1,744,847.634Z",
    transform: "translate(-638.72 -722.168)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M869.127,789.863a.511.511,0,0,1-.258-.692.477.477,0,0,1,.675-.3,53.778,53.778,0,0,1,5.755,3,56.461,56.461,0,0,1-6.172-2.015Z",
    transform: "translate(-738.445 -675.894)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M940.128,671.366a.511.511,0,0,1-.7-.232.478.478,0,0,1,.193-.713,53.969,53.969,0,0,1,5.954-2.589,56.161,56.161,0,0,1-5.446,3.534Z",
    transform: "translate(-794.746 -579.299)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M957.057,518.8a.509.509,0,0,1-.732.093.479.479,0,0,1-.136-.726,53.863,53.863,0,0,1,4.246-4.912,56.279,56.279,0,0,1-3.378,5.544Z",
    transform: "translate(-808.105 -455.897)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M872.493,456.674a.511.511,0,0,1-.3.673.478.478,0,0,1-.689-.266,54.008,54.008,0,0,1-1.957-6.191,56.3,56.3,0,0,1,2.95,5.784Z",
    transform: "translate(-739.019 -406.107)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M910.982,545.127a.512.512,0,0,1-.7.232.479.479,0,0,1-.272-.686,54,54,0,0,1,3.221-5.637,56.6,56.6,0,0,1-2.247,6.091Z",
    transform: "translate(-771.279 -476.478)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M871.891,608.809a.511.511,0,0,1-.421.607.479.479,0,0,1-.629-.386,53.634,53.634,0,0,1-.8-6.445,56.526,56.526,0,0,1,1.851,6.224Z",
    transform: "translate(-739.41 -527.212)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M855.339,719a.513.513,0,0,1-.726-.136.479.479,0,0,1,.094-.733,53.844,53.844,0,0,1,5.548-3.374A56.188,56.188,0,0,1,855.339,719Z",
    transform: "translate(-727 -616.765)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M794.952,756.111a.511.511,0,0,1-.709.206.478.478,0,0,1-.246-.7,53.77,53.77,0,0,1,3.439-5.509,56.582,56.582,0,0,1-2.484,6Z",
    transform: "translate(-678.655 -644.989)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M933.333,420.281a.51.51,0,0,1-.732.092.477.477,0,0,1-.134-.725,53.743,53.743,0,0,1,4.245-4.913,56.476,56.476,0,0,1-3.379,5.546Z",
    transform: "translate(-789.166 -377.244)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M876.34,386.161a.511.511,0,0,1-.343.654.477.477,0,0,1-.671-.3,53.7,53.7,0,0,1-1.594-6.3,56.591,56.591,0,0,1,2.609,5.946Z",
    transform: "translate(-742.362 -349.685)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M819.172,468.231a.511.511,0,0,1-.126.728.478.478,0,0,1-.732-.084,53.8,53.8,0,0,1-3.452-5.5,56.25,56.25,0,0,1,4.31,4.856Z",
    transform: "translate(-695.366 -416.075)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M803.2,591.432a.511.511,0,0,1-.124.728.479.479,0,0,1-.734-.084,53.755,53.755,0,0,1-3.451-5.5,56.681,56.681,0,0,1,4.309,4.856Z",
    transform: "translate(-682.618 -514.431)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M761.348,722.62a.511.511,0,0,1-.126.727.478.478,0,0,1-.734-.083,53.773,53.773,0,0,1-3.45-5.5,56.655,56.655,0,0,1,4.31,4.856Z",
    transform: "translate(-649.202 -619.164)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M700.527,802.948a.512.512,0,0,1-.459-.578.479.479,0,0,1,.552-.491,53.717,53.717,0,0,1,6.4,1.1,56.388,56.388,0,0,1-6.493-.026Z",
    transform: "translate(-603.721 -686.314)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M673.561,917.314a.51.51,0,0,1-.458-.578.479.479,0,0,1,.551-.491,53.966,53.966,0,0,1,6.4,1.1,56.108,56.108,0,0,1-6.493-.026Z",
    transform: "translate(-582.194 -777.617)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M527.174,308.093a.51.51,0,0,1-.193.712.478.478,0,0,1-.722-.151,54.033,54.033,0,0,1-2.926-5.8,56.462,56.462,0,0,1,3.841,5.235Z",
    transform: "translate(-462.627 -287.927)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M469.223,434.681a.511.511,0,0,1,.044.737.48.48,0,0,1-.734.086,54.185,54.185,0,0,1-4.614-4.569,56.407,56.407,0,0,1,5.3,3.746Z",
    transform: "translate(-415.194 -390.176)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M440,579.148a.511.511,0,0,1,.182.715.478.478,0,0,1-.7.224,53.874,53.874,0,0,1-5.4-3.61A56.269,56.269,0,0,1,440,579.148Z",
    transform: "translate(-391.371 -506.366)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M414.607,591.864a.51.51,0,0,1-.437.595.477.477,0,0,1-.619-.4,53.8,53.8,0,0,1-.634-6.463,56.6,56.6,0,0,1,1.689,6.27Z",
    transform: "translate(-374.468 -513.647)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M358.884,484.919a.512.512,0,0,1-.734-.084.479.479,0,0,1,.042-.738,54.023,54.023,0,0,1,5.3-3.757,56.563,56.563,0,0,1-4.6,4.578Z",
    transform: "translate(-330.633 -429.619)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M366.152,356.165a.511.511,0,0,1-.547-.495.478.478,0,0,1,.463-.574,53.247,53.247,0,0,1,6.493.03,56.654,56.654,0,0,1-6.409,1.039Z",
    transform: "translate(-336.704 -329.567)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M305.6,276.854a.511.511,0,0,1-.611.415.479.479,0,0,1-.449-.587,53.706,53.706,0,0,1,1.563-6.3,56.573,56.573,0,0,1-.5,6.473Z",
    transform: "translate(-287.947 -262)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M232.46,337.03a.512.512,0,0,1-.061.737.479.479,0,0,1-.738-.019,53.925,53.925,0,0,1-3.92-5.177,56.34,56.34,0,0,1,4.719,4.46Z",
    transform: "translate(-226.644 -311.648)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M228.694,485.833a.51.51,0,0,1,.35.649.479.479,0,0,1-.628.389,53.747,53.747,0,0,1-6.113-2.187,56.3,56.3,0,0,1,6.391,1.15Z",
    transform: "translate(-222.304 -433.082)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M263.449,405.089a.509.509,0,0,1-.067.734.477.477,0,0,1-.737-.025,53.929,53.929,0,0,1-3.88-5.206,55.992,55.992,0,0,1,4.684,4.5Z",
    transform: "translate(-251.411 -365.953)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M320.965,356.18a.513.513,0,0,1-.7.235.48.48,0,0,1-.273-.686,53.888,53.888,0,0,1,3.206-5.646,56.274,56.274,0,0,1-2.232,6.1Z",
    transform: "translate(-300.245 -325.629)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M319.026,459.461a.511.511,0,0,1-.618.4.479.479,0,0,1-.439-.594A54.059,54.059,0,0,1,319.635,453a56.186,56.186,0,0,1-.609,6.465Z",
    transform: "translate(-298.669 -407.789)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M314.261,551.555a.512.512,0,0,1-.151.724.479.479,0,0,1-.731-.11,53.791,53.791,0,0,1-3.258-5.616,56.6,56.6,0,0,1,4.14,5Z",
    transform: "translate(-292.41 -482.479)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M270.532,586.051a.511.511,0,0,1,.622.4.479.479,0,0,1-.363.643,53.589,53.589,0,0,1-6.408,1.043,56.222,56.222,0,0,1,6.149-2.084Z",
    transform: "translate(-255.898 -514)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M364.353,652.976a.51.51,0,0,1,.737.032.477.477,0,0,1,.011.737,53.69,53.69,0,0,1-5.011,4.129,56.024,56.024,0,0,1,4.263-4.9Z",
    transform: "translate(-332.303 -567.328)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M433.809,744.673a.511.511,0,0,1,.346.652.479.479,0,0,1-.631.384,53.769,53.769,0,0,1-6.1-2.236,56.376,56.376,0,0,1,6.381,1.2Z",
    transform: "translate(-386.062 -639.684)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M442.525,898.135a.513.513,0,0,1,.451.586.479.479,0,0,1-.56.481,53.565,53.565,0,0,1-6.381-1.2,56.707,56.707,0,0,1,6.491.129Z",
    transform: "translate(-392.933 -763.023)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M558.607,499.591a4.807,4.807,0,1,1-4.389-5.193,4.807,4.807,0,0,1,4.389,5.193Z",
    transform: "translate(-483.126 -440.829)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M559.943,503.521a1.71,1.71,0,1,1-1.56-1.848,1.71,1.71,0,0,1,1.56,1.848Z",
    transform: "translate(-489.129 -446.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M648.082,507.108a4.807,4.807,0,1,1-4.387-5.192,4.807,4.807,0,0,1,4.387,5.192Z",
    transform: "translate(-554.558 -446.83)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M649.422,511.036a1.711,1.711,0,1,1-1.562-1.849,1.711,1.711,0,0,1,1.562,1.849Z",
    transform: "translate(-560.563 -452.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M569.092,575.189a17.435,17.435,0,0,1,2.016.387,8.011,8.011,0,0,1,4.8,2.863.652.652,0,0,1-1.061.758,6.777,6.777,0,0,0-4.059-2.357,16.9,16.9,0,0,0-13.851,2.611.652.652,0,0,1-.758-1.06,18.261,18.261,0,0,1,12.914-3.2Z",
    transform: "translate(643.302 649.39) rotate(180)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(21.289 62.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M2211.865,353.123a7.133,7.133,0,0,1,1.671-.409,12.42,12.42,0,0,1,2.043-.108c-2.052-21.282,5.054-39.965,17.189-46.146l.261-4.217c-14.666,5.95-23.526,26.988-21.163,50.881Z",
    transform: "translate(-2205.092 -302.242)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M2188.3,500.054a10.14,10.14,0,1,0,10.33-11.724,11.7,11.7,0,0,0-1.919.1,6.666,6.666,0,0,0-1.569.384,10.148,10.148,0,0,0-6.842,11.238Z",
    transform: "translate(-2188.163 -438.593)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M2203.2,510.276a6.037,6.037,0,1,0,5.028-6.909,6.041,6.041,0,0,0-5.028,6.909Z",
    transform: "translate(-2199.027 -449.462)",
    fill: "#3ba5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M2207.424,513.19a4.876,4.876,0,1,0,4.06-5.571,4.881,4.881,0,0,0-4.06,5.571Z",
    transform: "translate(-2202.1 -452.558)",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M2429.308,492.613c-13.066-2.021-26.712,21.105-29.183,37.09-2.038,13.156,2.933,22.468,13.991,26.226l.718-2.1c-9.924-3.369-14.375-11.821-12.522-23.788,2.6-16.786,15.992-36.889,26.657-35.238,11.444,1.768,17.132,26.467,14.785,41.653a28.719,28.719,0,0,1-3.343,9.987c-3.12,5.542-8.58,8.755-15.776,8.9l.046,2.217c11.673-.241,19.23-7.616,21.263-20.771,2.47-15.985-3.557-42.156-16.638-44.178Z",
    transform: "translate(-2341.697 -440.338)",
    fill: "#e6e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M2444.38,713.429c.49-1.132-.6-2.7-2.437-3.507a4.2,4.2,0,0,0-4.235.588c-.347.481.594,2.7,2.438,3.51s3.73.54,4.234-.591Z",
    transform: "translate(-2369.25 -597.935)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M2481.535,719.605c-.13-1.232,1.386-2.4,3.385-2.607a4.2,4.2,0,0,1,3.859,1.835c.186.564-1.389,2.4-3.384,2.613s-3.725-.613-3.861-1.841Z",
    transform: "translate(-2401.11 -603.29)",
    fill: "#313860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M2503.383,347.7a12.62,12.62,0,0,1-.4,1.674l-1.51,5.223a71.059,71.059,0,0,1,1.123,23.285,86.57,86.57,0,0,1-1.534,8.793,1.915,1.915,0,0,0,1.384,2.276c.074.022.156,0,.238.028a1.887,1.887,0,0,0,2.043-1.443c.665-3.026,1.2-6.129,1.585-9.27a71.81,71.81,0,0,0-2.927-30.565Z",
    transform: "translate(-2415.257 -335.238)",
    fill: "#313860"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M2451.148,491.4c-6.919-1.072-14.663,4.559-21.248,15.439a1.441,1.441,0,0,0,2.466,1.489c5.865-9.689,12.723-14.95,18.337-14.081,5.64.867,10.59,7.958,13.251,18.964a1.441,1.441,0,1,0,2.8-.678c-2.988-12.358-8.672-20.063-15.606-21.134Z",
    transform: "translate(-2363.486 -439.456)",
    fill: "#313860"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactusHappy);
export default __webpack_public_path__ + "static/media/cactus-happy.a509c902dcb9f0c6f88ffcd354850ca5.svg";
export { ForwardRef as ReactComponent };